import {
  useHotelsStyles,
  useModuleBEM,
  useTenantImages,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
  ProductType,
} from "@b2bportal/core-types";
import {
  type HotelItinerarySummary,
  ReservationStateEnum,
} from "@b2bportal/lodging-api";
import { TripsCard } from "@tenant/trips";
import clsx from "clsx";
import defaultStyles from "./HotelReservationCard.module.scss";
import { useHotelReservationCard } from "./useHotelReservationCard";
import { TripsReservationStatusPill } from "@/components";

export interface HotelReservationCardComponentProps
  extends PlatformComponentProps {
  reservation: HotelItinerarySummary;
  selectItinerary: () => void;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelReservationCard;

export const HotelReservationCard = (
  props: HotelReservationCardComponentProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const images = useTenantImages();
  const { className, children, reservation } = props;
  const { handlers, text } = useHotelReservationCard(props);

  const isCancelled =
    reservation.state.ReservationState === ReservationStateEnum.Cancelled;
  const dateDisplay = (
    <span className={cn("date", { "date-cancelled": isCancelled })}>
      {text.dates}
    </span>
  );

  return (
    <TripsCard
      className={clsx(block, className)}
      title={text.title}
      onClick={handlers.selectItinerary}
      confirmationCode={reservation.reservationId}
      description={text.location}
      date={dateDisplay}
      image={images.hotelPlaceholder}
      status={
        <TripsReservationStatusPill
          variant={ProductType.LODGING}
          status={reservation.state.ReservationState}
        />
      }
    >
      {children}
    </TripsCard>
  );
};
